module.exports = __webpack_public_path__ + "static/media/VisualizeDataEvolution.b84bfbab.png";